import { ReusableWizard } from "@oysterhr/feature-components"
import { BankDetailsStepContractor } from "./steps/BankDetailsStepContractor"
import { AuthorizeDebitStepContractor } from "./steps/AuthorizeDebitStepContractor"

export const NewSepaContractorFlow = () => {
  return (
    <ReusableWizard>
      <BankDetailsStepContractor />
      <AuthorizeDebitStepContractor />
    </ReusableWizard>
  )
}
